module.exports = __webpack_public_path__ + "static/scale-model-of-cheetah-encounter-in-cincinnati-ohio-9783e18798f05f9ffe7653d54f437aa5.png";